import React, { FC, useEffect } from "react";
import { Box, Link, Stack, SxProps, Typography } from "@mui/material";
import { Colors } from "@src/gatsby-theme-material-ui-top-layout/colors-twentyfive";
import { aiChallengeURL } from "@src/urls";

interface Props {
  small?: boolean;
  sendToRegistration?: boolean;
}

const defaultTextStyle: SxProps = {
  fontFamily: "Inter",
  fontWeight: 700,
  fontSize: "48px",
  lineHeight: "100%",
  paddingBottom: "10px",
  background: `linear-gradient(63deg, #B4DAFF 7.18%, #E0BBFF 83.56%)`,
  backgroundClip: `text`,
  color: "transparent",
};

const AiChallengePlayNowButton: FC<Props> = ({
  small = false,
  sendToRegistration = false,
}) => {
  const defaultWidth = {
    xs: "360px",
    sm: "450px",
  };
  const smallWidth = "120px";

  const [glowStyle, setGlowStyle] = React.useState<SxProps>({});
  const [textStyle, setTextStyle] = React.useState<SxProps>(defaultTextStyle);

  useEffect(() => {
    setGlowStyle({
      position: "absolute",
      width: !small ? defaultWidth : smallWidth,
      height: !small ? "115px" : "30px",
      borderRadius: "30px",
    });

    if (small) {
      setTextStyle({
        ...defaultTextStyle,
        fontSize: "20px",
      });
    }
  }, [small]);

  return (
    <Link
      href={
        sendToRegistration
          ? aiChallengeURL
          : "/landing/ai-escape-room/#ai-challenge-registration"
      }
      sx={{
        display: "block",
        position: "relative",
        marginY: "80px",
        opacity: 1,
        textDecoration: "none",
        "&:hover": {
          opacity: 1, // need to override our default hover state,
          ".ai-challenge--countdown--highlight": {
            opacity: 1,
          },
          ".ai-challenge--counter": {
            borderColor: `rgba(211, 196, 235, 1) !important`,
          },
        },
      }}
    >
      {small ? (
        <Box
          sx={{
            ...glowStyle,
            boxShadow: `0px 0px 29px -4px rgba(151,99,232,1)`,
          }}
        />
      ) : (
        <>
          <Box
            sx={{
              ...glowStyle,
              boxShadow: `0px 0px 80px -15px rgba(255,255,255,0.2)`,
            }}
          />
          <Box
            sx={{
              ...glowStyle,
              boxShadow: `0px 0px 117px -20px rgba(255,255,255,0.7)`,
            }}
          />
          <Box
            className="ai-challenge--countdown--highlight"
            sx={{
              ...glowStyle,
              boxShadow: `0px 0px 117px -20px rgba(255,255,255,0.7)`,
              opacity: 0,
            }}
          />
          <Box
            sx={{
              ...glowStyle,
              boxShadow: `0px 13px 97px 17px #9763E8`,
            }}
          />
          <Box
            sx={{
              ...glowStyle,
              boxShadow: `0px 13px 37px 10pxrgb(138, 71, 247)`,
            }}
          />
          <Box
            className="ai-challenge--countdown--highlight"
            sx={{
              ...glowStyle,
              boxShadow: `0px 13px 37px 10pxrgb(138, 71, 247)`,
              opacity: 0,
            }}
          />
        </>
      )}
      <Box
        className="ai-challenge--counter"
        sx={{
          display: "flex",
          width: !small ? defaultWidth : smallWidth,
          height: !small ? "115px" : "30px",
          borderRadius: small ? "8px" : "30px",
          background: Colors.PrimaryGradient,
          border: `solid ${small ? "1px" : "2px"} rgba(211, 196, 235, 0.6)`,
          borderStyle: "solid",
          boxShadow: `0px 0px 71px -1px rgba(255,255,255,0.3)`,
          justifyContent: "center",
        }}
      >
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            height: !small ? "115px" : "30px",
            transformOrigin: "50% 50%",
            paddingTop: "20px",
            transform: `${
              small
                ? "translate3d(0px, -4px, 0px) scale3d(0.8, 0.8, 1)"
                : "translate3d(0px, -8px, 0px) scale3d(1, 1, 1)"
            }`,
          }}
          spacing={"0px"}
        >
          <Typography sx={textStyle}>Play now!</Typography>
        </Stack>
      </Box>
    </Link>
  );
};

export default AiChallengePlayNowButton;
